/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowReconcillationScopes {
    getFixupPrototypeFunction() { return WorkFlowReconcillationScopes.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowReconcillationScopes>): WorkFlowReconcillationScopes {
        let obj = Object.assign(new WorkFlowReconcillationScopes(), model);
        WorkFlowReconcillationScopes.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowReconcillationScopes>): WorkFlowReconcillationScopes {
        if (!model) return null;
        return WorkFlowReconcillationScopes.newInstance(<WorkFlowReconcillationScopes> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowReconcillationScopes) {
        if (!obj) return;

        models.WorkFlowReconcillationScopes.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowReconcillationScopes): boolean {
        Object.setPrototypeOf(obj, WorkFlowReconcillationScopes.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.generated_at === "string") {
            this.generated_at = new Date(<string><any>this.generated_at);
        }
    }

    /**
     * Date Filter for the impacted resources.
     */
    generated_at: Date;

    /**
     * Status of the policy resource recommendation
     */
    status: models.PolicyResourceRecommendationStatus;

    /**
     * Only include these sys Ids.
     */
    sys_ids: Array<string>;

    /**
     * Service account id
     */
    service_account_id: string;

    /**
     * Workflow ids for which the rules are required
     */
    workflow_ids: Array<string>;

}
